/**
 * Match device to a platform/OS id (e.g. plat-windows).
 * API may return device.platform as 'windows' or 'plat-windows'; this normalizes the match.
 */
export function deviceMatchesOS(device: { platform?: string; os?: string }, targetOS: string): boolean {
  if (!targetOS) return true;
  const plat = (device.platform || '').toLowerCase();
  const os = (device.os || '').toLowerCase();
  const norm = targetOS.replace(/^plat-/, '');
  return (
    device.platform === targetOS ||
    plat === norm ||
    plat === targetOS ||
    plat.includes(norm) ||
    os.includes(norm)
  );
}
